export const AFWTRList = {
  'AFWTR-SLC1E': {
    name: 'Space Launch Complex 2W',
    lat: 34.756104,
    lon: -120.626261,
    site: 'Vandenberg Space Force Base',
    country: 'United States',
    wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Space_Launch_Complex_2',
  },
  'AFWTR-LC576E': {
    name: 'Launch Complex 576E',
    lat: 34.7394,
    lon: -120.6192,
    site: 'Vandenberg Space Force Base',
    country: 'United States',
    wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Launch_Complex_576E',
  },
  'AFWTR-SLC4E': {
    name: 'Space Launch Complex 4E',
    lat: 34.633,
    lon: -120.613,
    site: 'Vandenberg Space Force Base',
    country: 'United States',
    wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Space_Launch_Complex_4',
  },
  'AFWTR-SLC8': {
    name: 'Space Launch Complex 8',
    lat: 34.5762,
    lon: -120.6324,
    site: 'Vandenberg Space Force Base',
    country: 'United States',
    wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Space_Launch_Complex_8',
  },
  WRAS: {
    name: 'Western Range Airspace',
    lat: 34.7,
    lon: -120.635,
    site: 'Vandenberg Space Force Base',
    country: 'United States',
    wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Space_Force_Base',
  },
};
